import { GetSafetyCode, AddSafety, GetSafetyStorage, GetLocalActiveCodeLIst, CreateActivationCode, GetCheckFileData } from '@/api/safety'
export default {
  state: {

  },
  actions: {
    GetSafetyCode ({ commit }, payload) {
      return new Promise(resolve => {
        GetSafetyCode(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetSafetyStorage ({ commit }, payload) {
      return new Promise(resolve => {
        GetSafetyStorage(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    AddSafety ({ commit }, payload) {
      return new Promise(resolve => {
        AddSafety(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetLocalActiveCodeLIst ({ commit }, payload) {
      return new Promise(resolve => {
        GetLocalActiveCodeLIst(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    CreateActivationCode ({ commit }, payload) {
      return new Promise(resolve => {
        CreateActivationCode(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetCheckFileData ({ commit }, payload) {
      return new Promise(resolve => {
        GetCheckFileData(payload).then(res => {
          resolve(res.data)
        })
      })
    }
  },
  getters: {

  },
  mutations: {

  }
}
